export const locale = {
    lang: 'zh2',
    data: {
      'EDITOR': {
        'CARGANDO': '加载信息',
        'GUARDANDO': '保存更改',
        'ELEMENTOS': {
          'GUIA': '该块的元素',
          'COLORES': {
            'ORIGINAL': '未修改的元素',
            'MODIFICADO': '修改品'
          },
          'TOOLTIPS': {
            'ORIGINAL': '尚未修改任何元素',
            'MODIFICADO': '一个或多个项目已被修改',
            'COMPLETO': '所有元素均已修改',
            'AMPLIAR': '查看大图',
            'ELIMINAR': '删除这张图片',
            'IMPORTAR': '从其他语言导入该项目',
            'CONFIGDOMINIO': '后端域配置',
            'COPIARURL': '复制链接'
          },
          'ETIQUETAS': {
            'INTERFAZ': {
              'TITULO': '经纪人配置',
              'SUBTITULO': '您可以查看和修改每个可用代理的设置',
              'PASOINICIAL': '从列表中选择一个代理以显示其配置',
              'SELBROKER': '选定经纪人',
              'SELOPC': '选择的选项',
              'SINJSONS': '无法从该经纪人加载信息，请稍后再试',
              'DOMINIO': {
                'TITULO': '代理后端域配置',
                'ACTIVAR': '激活与代理关联的域',
                'DOMINIO': '与经纪人关联的域'
              },
              'MODAL': {
                'TITULO': '导入元素',
                'SUBTITULO': '选择您要从中导入此项目的语言'
              }
            },
            'IMAGEN': {
              'NOHAY': '没有图像',
              'ACTUAL': '当前图像'
            },
            'TEXTO': {
              'INGRESAR': '输入你的文字'
            },
            'VIDEO': {
              'NOVIDEO': '您尚未上传视频',
              'GUARDANDO': '正在保存视频，请在完成上传之前退出此屏幕'
            }
          },
          'BOTONES': {
            'ENTRAR': '编辑调查特征',
            'REGRESAR': '回去',
            'CONTINUAR': '继续',
            'CANCELAR': '取消',
            'GUARDAR': '保存更改',
            'IMAGEN': '变更图片',
            'EDITOR': '编辑讯息',
            'ELEMENTOS': '帮助',
            'ACTIVAR': '表演',
            'DESACTIVAR': '隐藏',
            'VERVIDEO': '看视频',
            'CARGARVIDEO': '上传视频文件',
            'OTROVIDEO': '上载另一个视频文件',
            'SI': '是的',
            'NO': '不',
            'INFO': '重要的',
            'ADDIMG': '添加图片'
          },
          'MODALIMAGEN': {
            'TITULO': '将图片添加到消息',
            'TABS': {
              'INSTRUCCIONES': {
                'TITULO': '指示',
                'PASO_1': '点击\'图片\'标签，您可以选择已经上传的图片，也可以上传新图片',
                'PASO_2': '如果您想选择已上传的图片，将光标放在所需的图片上，您可以执行两种操作：查看图片或复制链接',
                'PASO_2_1': '要预览，请单击图像上带有以下图标的按钮',
                'PASO_2_2': '要复制链接，请单击带有以下图标的图像上的按钮',
                'PASO_3': '如果要上传新图片，请单击带有以下图标的按钮',
                'PASO_4': '当你上传完图片后，你会自动得到它的链接',
                'PASO_5': '返回消息编辑器，点击按钮插入图片，图标如下',
                'PASO_6': '在弹出窗口中放置复制的链接并设置图像大小，以像素表示。完成后，单击“保存”按钮。弹出窗口将关闭，图像将被放置在具有设置大小的编辑器中'
              },
              'IMAGENES': {
                'TITULO': '图片',
                'CARGANDO': '加载可用图像',
                'NOTA': '* 此处显示的图像保存在文件管理器中',
                'TITULO_2': '可用图像',
                'ADD': '添加新图像',
                'NOIMG': '没有可用的图像',
                'URLCOPIADA': '图片链接已复制到剪贴板',
                'OKBOT': '好的'
              },
            }
          }
        },
        'CATALOGOS': {
          'temas': {
            'temaFocusArea2': '颜色设置1',
            'theme-temaIzzi': '彩色套装2',
            'theme-blue-gray-dark': '彩色套装3',
            'theme-pink-dark': '颜色设置4',
            'theme-temaIzzi-2': '彩色套装5',
            'theme-temaItbm': '彩色套装6',
          },
          'numColumnas': {
            '1': '1列',
            '4': '4列',
            '5': '5列',
          },
          'segundos': {
            '1000': '1秒',
            '2000': '2秒',
            '3000': '3秒',
            '4000': '4秒',
            '5000': '5秒',
            '6000': '6秒',
            '7000': '7秒',
            '8000': '8秒',
            '9000': '9秒',
            '10000': '10秒',
            '11000': '11秒',
            '12000': '12秒',
            '13000': '13秒',
            '14000': '14秒',
            '15000': '15秒',
            '16000': '16秒',
            '17000': '17秒',
            '18000': '18秒',
            '19000': '19秒',
            '20000': '20秒',
          },
          'logosIniciales': {
            '0': 'CulturalGO徽标'
          }
        },
        'ADVERTENCIAS': {
          'URLEXTERNA': '警告：如果源站点不允许从外部站点访问页面，则不会显示内容',
          'TEMPLATEFALTANTE': '警告：此模板不适用于该语言',
          'CONFIGURACION': {
            'ACTIVAR': '警告：激活自定义配置时，此屏幕上指定的所有项目都将放置在平台界面中，请确保您已放置所有正确的项目\n\n是否要继续并激活自定义配置？',
            'DESACTIVAR': '警告：停用自定义配置时，将放置在平台中为此代理以及所有属于该代理的用户建立的默认元素。\n\n是否要继续并停用个性化配置？ '
          },
          'PRIORIDAD': {
            '1': '如果此元素处于活动状态，则将优先于背景图像',
            '2': '如果此元素处于活动状态，则将优先于背景图像和视频背景。'
          }
        },
        'PANTALLAS': {
          'LOGIN': {
            'TITULO': '登录',
            'PASOS': {
              'VARIOS': {
                'TITULO': '杂件',
                'ELEMENTOS': {
                  'images_broker': '经纪人徽标',
                  'title': '主题',
                  'images_login': '系统徽标',
                  'images_logout': '注销时显示的图像',
                  'changeTime': '图像之间的时间间隔'
                }
              },
              'BACKGROUNDS': {
                'TITULO': '背景图片',
                'ELEMENTOS': {
                  'agregar': '新增图片',
                  'importar': '从其他设置导入图像',
                }
              },
              'VIDEO': {
                'TITULO': '背景视频',
                'ELEMENTOS': {
                  'enable': '启用背景视频',
                  'video': '要显示的视频',
                  'loop': '启用自动重复',
                  'mute': '显示静音的视频'
                }
              },
              'EXTERNO': {
                'TITULO': '外部内容',
                'ELEMENTOS': {
                  'enable': '启用外部内容',
                  'url': '外部内容链接显示',
                }
              }
            }
          },
          'HOME': {
            'TITULO': '主页',
            'PASOS': {
              'BRAND':{
                'TITULO': '侧面菜单中的系统ID',
                'ELEMENTOS': {
                  'logo': '系统徽标',
                  'name': '系统名称'
                }
              },
              'LOGOINICIAL': {
                'TITULO': '初始徽标',
                'ELEMENTOS': {
                  'show': '显示初始系统徽标',
                  'time': '徽标显示时间（以秒为单位）',
                  'type': '要显示的初始徽标类型'
                }
              },
              'MOSAICO': {
                'TITULO': '图像拼接',
                'ELEMENTOS': {
                  'branding_show': '显示系统品牌徽标',
                  'branding_image': '系统品牌徽标',
                  'grayFilter': '启动图像上的灰色滤镜',
                  'bgGridColumns': '要显示的图像列数'
                }
              },
              'TEMAS': {
                'TITULO': '平台颜色主题',
                'ELEMENTOS': {
                  'theme': '在系统中显示的颜色主题'
                }
              },
              'BACKGROUNDS': {
                'TITULO': '背景图片',
                'ELEMENTOS': {
                  'agregar': '新增图片',
                  'importar': '从其他设置导入图像',
                }
              },
              'VIDEO': {
                'TITULO': '背景视频',
                'ELEMENTOS': {
                  'enable': '启用背景视频',
                  'video': '要显示的视频',
                  'loop': '启用自动重复',
                  'mute': '显示静音的视频'
                }
              },
              'EXTERNO': {
                'TITULO': '外部内容',
                'ELEMENTOS': {
                  'enable': '启用外部内容',
                  'url': '外部内容链接显示',
                }
              },
              'LOADER': {
                'TITULO': '图片 .gif 加载',
                'ELEMENTOS': {
                  'image': '图片加载.gif',
                  'GUARDANDO': '正在保存图像，加载完成前不要退出此屏幕'
                }
              },
            }
          },
          'TEMPLATES': {
            'TITULO': '电子邮件范本',
            'PASOS': {
              'RT_1': {
                'TITULO': '技术要求，在注册新产品时发送',
                'ELEMENTOS': {
                  'asunto': '邮件主题',
                  'mensaje': '邮件正文'
                }
              },
              'RT_2': {
                'TITULO': '技术要求，验证期间发送的演示消息',
                'ELEMENTOS': {
                  'asunto': '邮件主题',
                  'mensaje': '邮件正文'
                }
              },
              'PASS_3': {
                'TITULO': '更新用户密码时发送的邮件',
                'ELEMENTOS': {
                  'asunto': '邮件主题',
                  'mensaje': '邮件正文'
                }
              },
              'PASS_4': {
                'TITULO': '更新用户个人资料时发送的电子邮件',
                'ELEMENTOS': {
                  'asunto': '邮件主题',
                  'mensaje': '邮件正文'
                }
              },
              'GETMYCODE_6': {
                'TITULO': '使用 GetMyCode 发送的邮件',
                'ELEMENTOS': {
                  'asunto': '邮件主题',
                  'mensaje': '邮件正文'
                }
              },
              'RT_7': {
                'TITULO': '技术要求验收邮件',
                'ELEMENTOS': {
                  'asunto': '邮件主题',
                  'mensaje': '邮件正文'
                }
              },
            }
          }
        }
      }
    }
};
